module.exports = __webpack_public_path__ + "static/media/darkFast-forward2.96919a81.svg";